module.exports = __webpack_public_path__ + "img/calendar2-month.b2a1e7b9.svg";